<template>
  <div>
    <v-menu :nudge-width="150" offset-y :nudge-left="150">
      <template v-slot:activator="{ on }">
        <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Product operations</v-btn>
        <v-btn small icon v-on="on" v-on:click.prevent v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
      </template>
      <v-list dense>
        <v-list-item :to="{name:'InventoryProductsTransactions',params:{productId:product.id},query:{siteId}}"><v-list-item-title>Transactions</v-list-item-title></v-list-item>
        <v-list-item v-if="product.onSalesOrder.length"
                     :to="{name:'SalesSalesOrders',query:{itemId:product.id,itemName:product.name}}"><v-list-item-title>Open sales orders</v-list-item-title></v-list-item>

        <v-list-item v-if="company.allowAudit && company.permissions.includes('audit')" :to="{name:'Audit',query:{entityId:product.id}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
        <template v-if="!readOnly">
          <v-divider/>
          <v-menu v-if="!product.mixedPack" :nudge-left="200">
            <template v-slot:activator="{on:reduce}">
              <v-list-item v-on="reduce">
                <v-list-item-title>Bottling</v-list-item-title>
                <v-list-item-action><v-icon>mdi-chevron-right</v-icon></v-list-item-action>
              </v-list-item>
            </template>
            <v-list dense>
              <v-list-item :to="{name:'ProductionBottlingEditNew',params:{productId:product.id}}"><v-list-item-title>Bottle</v-list-item-title></v-list-item>
              <v-list-item @click="estimateCost(product.id)"><v-list-item-title>Estimate bottling cost</v-list-item-title></v-list-item>
              <v-list-item @click="printBottling(product.id,{},true)"><v-list-item-title>Print bottling form</v-list-item-title></v-list-item>
              <v-divider/>
              <v-list-item :to="{name:'ReportsView',params:{back:[{text:'Products',to:{name:'InventoryProducts'}}]},query:{to:'reports/production/ReportsBottlingActivity',productId:product.id}}"><v-list-item-title>Bottling activity report</v-list-item-title></v-list-item>
              <v-list-item :to="{name:'ReportsView',params:{back:[{text:'Products',to:{name:'InventoryProducts'}}]},query:{to:'reports/production/ReportsBottlingLosses',productId:product.id}}"><v-list-item-title>Bottling losses report</v-list-item-title></v-list-item>
            </v-list>
          </v-menu>
          <v-list-item v-else :to="{name:'ProductionPackingEditNew',params:{productId:product.id}}"><v-list-item-title>Pack mixed-pack</v-list-item-title></v-list-item>
          <v-menu :nudge-left="200">
            <template v-slot:activator="{on:reduce}">
              <v-list-item v-on="reduce">
                <v-list-item-title>Reduce/move inventory</v-list-item-title>
                <v-list-item-action><v-icon>mdi-chevron-right</v-icon></v-list-item-action>
              </v-list-item>
            </template>
            <v-list dense>
              <template>
                <template if="product.alcoholType!=='NonExcise'">
                  <v-list-item :to="{name:'InventoryProductsMoveToDutyPaid',params:{productId:product.id}}"><v-list-item-title>Move to duty paid</v-list-item-title></v-list-item>
                  <v-list-item :to="{name:'InventoryProductsMoveToInBond',params:{productId:product.id}}"><v-list-item-title>Return to in-bond</v-list-item-title></v-list-item>
                </template>
                <v-list-item v-if="!product.mixedPack" :to="{name:'InventoryProductsReturnToTank',params:{productId:product.id}}"><v-list-item-title>Return to tank</v-list-item-title></v-list-item>
                <v-list-item v-else :to="{name:'InventoryProductsUnpack',params:{productId:product.id}}"><v-list-item-title>Unpack</v-list-item-title></v-list-item>
              </template>
              <v-list-item v-if="!product.mixedPack" :to="{name:'InventoryProductsConvert',params:{productId:product.id}}"><v-list-item-title>Convert to other product</v-list-item-title></v-list-item>
              <v-divider/>
              <v-list-item :to="{name:'InventoryProductsReduceInventory',params:{productId:product.id}}"><v-list-item-title>Reduce inventory</v-list-item-title></v-list-item>
              <v-list-item :to="{name:'InventoryProductsAdjustInventory',params:{productId:product.id}}"><v-list-item-title>Adjust inventory</v-list-item-title></v-list-item>
              <v-list-item v-if="company.settings.lotTrackingForProducts" :to="{name:'InventoryProductsTransferLot',params:{productId:product.id}}"><v-list-item-title>Reassign lot</v-list-item-title></v-list-item>
              <v-list-item v-if="sites.length>1" :to="{name:'InventoryProductsTransferSite',params:{productId:product.id}}"><v-list-item-title>Move to site</v-list-item-title></v-list-item>
            </v-list>
          </v-menu>

          <v-divider/>
          <generate-qr-code type="Product" :id="product.id" ask-quantity quantityUnits="cases" cases ask-lot :lots="lots(product)"/>
          <v-list-item :to="{name:'InventoryProductsEdit',params:{productId:product.id}}"><v-list-item-title>Edit product</v-list-item-title></v-list-item>
          <v-list-item @click="$emit('delete')"><v-list-item-title>Delete product</v-list-item-title></v-list-item>
        </template>
      </v-list>
    </v-menu>

    <component :is="dialog" :productId="productId" @done="dialog = null"/>
  </div>
</template>

<script>
import productionBottlingPrintBottling from '@/views/production/bottling/productionBottlingPrintBottling'
import generateQrCode from '@/components/GenerateQrCode'

export default {
  name: 'InventoryProductMenu',
  mixins: [productionBottlingPrintBottling],
  components: {generateQrCode},
  props: {
    product: {type:Object, required:true},
    siteId: {type:String, required:false, default:null},
    readOnly: {type:Boolean, required:false, default:false},
  },
  data() {
    return {
      dialog: null,
      productId: ''
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    connectedToAccounting() {
      return this.company.connectedToAccounting;
    },
    sites() {
      return this.$store.getters.sites(true);
    }
  },
  methods: {
    estimateCost(productId) {
      this.productId = productId;
      this.dialog = () => import('@/views/inventory/products/InventoryProductsEstimateCost');
    },
    lots(product) {
      return product.sites.map(site => site.inBondBottles ? site.lot : '').filter(lot => !!lot);
    }
  }
}
</script>